var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_914_56569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8321 15.5903V14.7694C11.8321 10.2375 6.53342 6.56543 0.00842285 6.56543V23.7943C0.00842285 28.3261 5.30545 31.9999 11.8321 31.9999C18.3588 31.9999 23.6558 28.3261 23.6558 23.7943C23.6558 19.2624 18.3656 15.5903 11.8321 15.5903Z",
    fill: "url(#paint0_linear_914_56569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8322 23.7962V24.6154C15.962 24.6154 19.602 26.0832 21.7117 28.3077C22.9448 27.0122 23.6643 25.4616 23.6643 23.7945C23.6643 19.2626 18.3656 15.5888 11.8406 15.5888V14.7679C11.8406 10.2361 6.54191 6.56396 0.0169067 6.56396V15.5888C6.53346 15.5905 11.8322 19.2643 11.8322 23.7962Z",
    fill: "url(#paint1_linear_914_56569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6643 0C17.1292 0 11.8406 3.67379 11.8406 8.20565V23.796C11.8406 26.8364 9.45899 29.4816 5.92877 30.9004C7.81166 31.6393 9.81798 32.013 11.8406 32.0017C18.3741 32.0017 23.6643 28.3279 23.6643 23.796V0Z",
    fill: "url(#paint2_linear_914_56569)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_914_56569",
    x1: -0.0000226564,
    y1: 19.2827,
    x2: 23.6643,
    y2: 19.2827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#08B1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2A87C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4368AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#53569E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#584F99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_914_56569",
    x1: 11.8322,
    y1: -0.2752,
    x2: 11.8322,
    y2: 24.2877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#01ABEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#028AE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0376E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#036FE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_914_56569",
    x1: 14.7898,
    y1: -9.44545,
    x2: 14.7898,
    y2: 27.7012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BAEC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_914_56569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.6643,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.66375a70c78cd430dce85851610a3595.svg";
export { ForwardRef as ReactComponent };